/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Kyc_VerifyInputs */

const en_label_kyc_verify = /** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KYC Verification`)
};

const es_label_kyc_verify = /** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación KYC`)
};

const fr_label_kyc_verify = /** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification KYC`)
};

const de_label_kyc_verify = /** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KYC-Verifizierung`)
};

const id_label_kyc_verify = /** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi KYC`)
};

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const ja_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const zh_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const ar_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const it_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const ru_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const pt_label_kyc_verify = en_label_kyc_verify;

/** @type {(inputs: Label_Kyc_VerifyInputs) => LocalizedString} */
const ko_label_kyc_verify = en_label_kyc_verify;

/**
* | output |
* | --- |
* | "KYC Verification" |
*
* @param {Label_Kyc_VerifyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_kyc_verify = /** @type {((inputs?: Label_Kyc_VerifyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Kyc_VerifyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_kyc_verify(inputs)
	if (locale === "es") return es_label_kyc_verify(inputs)
	if (locale === "fr") return fr_label_kyc_verify(inputs)
	if (locale === "de") return de_label_kyc_verify(inputs)
	if (locale === "ja") return ja_label_kyc_verify(inputs)
	if (locale === "zh") return zh_label_kyc_verify(inputs)
	if (locale === "ar") return ar_label_kyc_verify(inputs)
	if (locale === "id") return id_label_kyc_verify(inputs)
	if (locale === "it") return it_label_kyc_verify(inputs)
	if (locale === "ru") return ru_label_kyc_verify(inputs)
	if (locale === "pt") return pt_label_kyc_verify(inputs)
	return ko_label_kyc_verify(inputs)
});